<div class="dt-container rounded-lg" [formGroup]="form" (blur)="onTouched()">
  <div class="date-container">
    <app-date-picker
      formControlName="date"
      variant="blend"
      placeholder="Select date"
    ></app-date-picker>
  </div>
  <div class="time-container">
    <app-time-picker
      formControlName="time"
      variant="blend"
      placeholder="Select time"
    ></app-time-picker>
  </div>
</div>
